import { axiosInstance } from '.'
import {
  ADMIN_ROLE_DEFINITION_V1,
  DELETE_ADMIN_V1,
  LIST_ADMIN_ROLE_DEFINITIONS_V1,
  LIST_ADMINS_V1,
  RESET_ADMIN_PASSWORD_V1,
  UPDATE_ADMIN_ROLE_V1,
} from './endpoints'

export type AdminRosterRow = {
  id: number
  name: string
  email: string
  role: string
  created_at: string
  updated_at: string
}

export type AdminRoleDefinitionRow = {
  id: number
  code: string
  display_name: string
  permissions: Record<string, string>
  is_system: boolean
  created_at: string
  updated_at: string
}

export const adminTeamServices = {
  listAdmins: async () => {
    try {
      return await axiosInstance.get<AdminRosterRow[]>(LIST_ADMINS_V1)
    } catch (error: any) {
      return error.response
    }
  },

  listRoleDefinitions: async () => {
    try {
      return await axiosInstance.get<AdminRoleDefinitionRow[]>(LIST_ADMIN_ROLE_DEFINITIONS_V1)
    } catch (error: any) {
      return error.response
    }
  },

  createRoleDefinition: async (body: {
    code: string
    display_name: string
    permissions: Record<string, string>
  }) => {
    try {
      return await axiosInstance.post(LIST_ADMIN_ROLE_DEFINITIONS_V1, body)
    } catch (error: any) {
      return error.response
    }
  },

  updateRoleDefinition: async (
    code: string,
    body: { display_name?: string; permissions?: Record<string, string> },
  ) => {
    try {
      return await axiosInstance.patch(ADMIN_ROLE_DEFINITION_V1(code), body)
    } catch (error: any) {
      return error.response
    }
  },

  deleteRoleDefinition: async (code: string) => {
    try {
      return await axiosInstance.delete(ADMIN_ROLE_DEFINITION_V1(code))
    } catch (error: any) {
      return error.response
    }
  },

  createAdmin: async (body: { name: string; email: string; password: string; role: string }) => {
    try {
      return await axiosInstance.post(LIST_ADMINS_V1, body)
    } catch (error: any) {
      return error.response
    }
  },

  updateAdminRole: async (id: number, role: string) => {
    try {
      return await axiosInstance.patch(UPDATE_ADMIN_ROLE_V1(id), { role })
    } catch (error: any) {
      return error.response
    }
  },

  deleteAdmin: async (id: number) => {
    try {
      return await axiosInstance.delete(DELETE_ADMIN_V1(id))
    } catch (error: any) {
      return error.response
    }
  },

  resetAdminPassword: async (id: number) => {
    try {
      return await axiosInstance.post<{ temporaryPassword: string; email: string }>(
        RESET_ADMIN_PASSWORD_V1(id),
      )
    } catch (error: any) {
      return error.response
    }
  },
}
